import { Component } from '@angular/core';

@Component({
    selector: 'logo',
    templateUrl: 'logo.component.html',
    styleUrls: ['logo.component.scss'],
    standalone: false
})
export class LogoComponent {

}